import React from 'react';
import { FieldArray } from 'redux-form';
import { withI18n } from '@shopify/react-i18n';
import ProductsTable from 'src/components/views/merchandising-v2/rule/strategy/products/products-table';
import { TextStyle } from '@shopify/polaris';
import { NUMBER_CONDITION_PER_TYPE } from 'src/constants/merchandising-v2';

const SelectProduct = (props) => {
  const {
    i18n,
    type,
    ruleType,
    appLanguage,
    updateField,
    collections,
    renderPreview,
    options
  } = props;

  return (
    <div>
      <div style={{ padding: '20px 20px 0px 20px' }}>
        <TextStyle>
          {i18n.translate('AdminHTML.MerchandisingV2.Improvement.selectProduct', {
            t1: NUMBER_CONDITION_PER_TYPE[type] || '3',
            t2: i18n.translate(`AdminHTML.MerchandisingV2.Rule.${type}ButtonTitle`)
          })}
        </TextStyle>
      </div>
      <FieldArray
        name={`products[${type}]`}
        component={ProductsTable}
        type={type}
        ruleType={ruleType}
        options={options}
        appLanguage={appLanguage}
        updateField={updateField}
        collections={collections}
        renderPreview={renderPreview}
        renderValueFieldOnly={true}
      />
    </div>
  )
}

export default withI18n()(SelectProduct);
